module.exports = __webpack_public_path__ + "static/img/merchant_case_1.d5f0efa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/uupay/images/merchant_case_1.png
// module id = hVaj
// module chunks = 8